/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IdentityMelcoModelsCulture
 */
export interface IdentityMelcoModelsCulture {
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsCulture
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsCulture
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsCulture
     */
    short_code: string;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsCulture
     */
    name: string;
}

export function IdentityMelcoModelsCultureFromJSON(json: any): IdentityMelcoModelsCulture {
    return IdentityMelcoModelsCultureFromJSONTyped(json, false);
}

export function IdentityMelcoModelsCultureFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityMelcoModelsCulture {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'short_code': json['short_code'],
        'name': json['name'],
    };
}

export function IdentityMelcoModelsCultureToJSON(value?: IdentityMelcoModelsCulture | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'code': value.code,
        'short_code': value.short_code,
        'name': value.name,
    };
}


